import initialState from './../../initialState';

export default (state = initialState.mudancas, { type, value, response }) => {
  switch (type) {
    case 'LIST_MUDANCAS_REQUEST':
      return {
        ...state,
        fetching: 1,
        errors: []
      };
    case 'LIST_MUDANCAS_SUCCESS':
      return {
        ...state,
        ...response,
        fetching: 2
      };
    case 'CANCEL_MUDANCAS_SUCCESS':
      return {
        ...state,
        result: state.result.filter(v => v !== value)
      };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/modules/mudancas/reducer.js